import { usePumpSizing } from "../../../context/PumpSizingContext";
import { CheckboxField } from "../../shared/CheckboxField";
import { RadioGroup } from "../../shared/RadioGroup";
import { TextField } from "../../shared/TextField";

export function GpmSumpHelp() {
	const { formData, updateSumpGpm } = usePumpSizing();
	const { sump } = formData.gpmData;

	return (
		<div className="pf-gpm-help pf-gpm-help--sump">
			<RadioGroup
				label="Drainage Type*"
				name="drainageType"
				value={sump.drainageType}
				onChange={(value) =>
					updateSumpGpm({
						drainageType: value as typeof sump.drainageType,
					})
				}
				options={[
					{ value: "basement", label: "Basement" },
					{ value: "surface", label: "Surface" },
				]}
			/>

			<div className="pf-gpm-help__section">
				<RadioGroup
					label="Area being Drained*"
					name="areaMode"
					value={sump.areaMode}
					onChange={(value) =>
						updateSumpGpm({
							areaMode: value as typeof sump.areaMode,
						})
					}
					options={[
						{ value: "dimensions", label: "Dimensions" },
						{ value: "sqft", label: "Area (sqft)" },
					]}
				/>

				{sump.areaMode === "dimensions" ? (
					<div className="pf-gpm-help__inline-fields">
						<TextField
							label="Length (ft)"
							type="number"
							value={sump.length}
							onChange={(event) =>
								updateSumpGpm({ length: event.target.value })
							}
							min="0"
							step="any"
						/>
						<TextField
							label="Width (ft)"
							type="number"
							value={sump.width}
							onChange={(event) =>
								updateSumpGpm({ width: event.target.value })
							}
							min="0"
							step="any"
						/>
					</div>
				) : (
					<TextField
						label="Area (sqft)*"
						type="number"
						value={sump.areaSqft}
						onChange={(event) =>
							updateSumpGpm({ areaSqft: event.target.value })
						}
						min="0"
						step="any"
						className="pf-field-group--full"
					/>
				)}
			</div>

			<CheckboxField
				label="Enter rainfall manually"
				checked={sump.manualRainfall}
				onChange={(checked) =>
					updateSumpGpm({
						manualRainfall: checked,
						lat: "",
						lon: "",
						rainfall: "",
					})
				}
			/>

			{sump.manualRainfall ? (
				<TextField
					label="Rainfall (in)*"
					type="number"
					value={sump.rainfall}
					onChange={(event) =>
						updateSumpGpm({ rainfall: event.target.value })
					}
					min="0"
					step="any"
					className="pf-field-group--full"
				/>
			) : (
				<TextField
					label="ZIP Code*"
					type="text"
					value={sump.zipCode}
					onChange={(event) =>
						updateSumpGpm({
							zipCode: event.target.value,
							lat: "",
							lon: "",
							rainfall: "",
						})
					}
					className="pf-field-group--full"
				/>
			)}
		</div>
	);
}
